export default "__VITE_ASSET__CgbV1ivg__"